export default __webpack_public_path__ + "static/media/calendar.ed3bc885.svg";